import { useLayoutEffect, useRef } from "react";

const CompactHorizontalScroll = ({ children, className = "", contentKey }) => {
  const topRef = useRef(null);
  const topInnerRef = useRef(null);
  const bodyRef = useRef(null);
  const bodyInnerRef = useRef(null);

  useLayoutEffect(() => {
    const topEl = topRef.current;
    const topInnerEl = topInnerRef.current;
    const bodyEl = bodyRef.current;
    const bodyInnerEl = bodyInnerRef.current;
    if (!topEl || !topInnerEl || !bodyEl || !bodyInnerEl) return;

    const scrollable = bodyEl.querySelector(".ant-table-body") || bodyEl;
    const header = bodyEl.querySelector(".ant-table-header");
    const usesAntTableBody = scrollable !== bodyEl;

    const getContentWidth = () => {
      const bodyTable = bodyInnerEl.querySelector(".ant-table-body table");
      const headerTable = bodyInnerEl.querySelector(".ant-table-header table");
      const table = bodyInnerEl.querySelector("table");
      const antTable = bodyInnerEl.querySelector(".ant-table");
      const content =
        bodyTable || headerTable || table || antTable || bodyInnerEl.firstElementChild || bodyInnerEl;

      return Math.max(
        bodyTable?.scrollWidth || 0,
        headerTable?.scrollWidth || 0,
        content?.scrollWidth || 0,
        content?.offsetWidth || 0,
        scrollable.scrollWidth || 0,
      );
    };

    const setInnerWidths = () => {
      const width = getContentWidth();
      topInnerEl.style.width = `${width}px`;

      // Keep ant-table at viewport width so .ant-table-body owns horizontal scroll.
      if (usesAntTableBody) {
        bodyInnerEl.style.width = "";
        bodyInnerEl.style.minWidth = "100%";
      } else {
        bodyInnerEl.style.minWidth = "";
        bodyInnerEl.style.width = `${width}px`;
      }
    };

    setInnerWidths();

    const resizeObserver = new ResizeObserver(setInnerWidths);
    resizeObserver.observe(bodyInnerEl);
    const table = bodyInnerEl.querySelector("table");
    const bodyTable = bodyInnerEl.querySelector(".ant-table-body table");
    const headerTable = bodyInnerEl.querySelector(".ant-table-header table");
    const antTable = bodyInnerEl.querySelector(".ant-table");
    if (bodyTable) resizeObserver.observe(bodyTable);
    if (headerTable) resizeObserver.observe(headerTable);
    if (table) resizeObserver.observe(table);
    if (antTable) resizeObserver.observe(antTable);
    if (usesAntTableBody) resizeObserver.observe(scrollable);

    const onTopScroll = () => {
      scrollable.scrollLeft = topEl.scrollLeft;
      if (header) header.scrollLeft = topEl.scrollLeft;
    };

    const onBodyScroll = () => {
      topEl.scrollLeft = scrollable.scrollLeft;
      if (header) header.scrollLeft = scrollable.scrollLeft;
    };

    const onHeaderScroll = header
      ? () => {
          topEl.scrollLeft = header.scrollLeft;
          scrollable.scrollLeft = header.scrollLeft;
        }
      : null;

    topEl.addEventListener("scroll", onTopScroll);
    scrollable.addEventListener("scroll", onBodyScroll);
    if (header && onHeaderScroll) header.addEventListener("scroll", onHeaderScroll);

    requestAnimationFrame(setInnerWidths);

    return () => {
      resizeObserver.disconnect();
      topEl.removeEventListener("scroll", onTopScroll);
      scrollable.removeEventListener("scroll", onBodyScroll);
      if (header && onHeaderScroll) header.removeEventListener("scroll", onHeaderScroll);
    };
  }, [children, contentKey]);

  return (
    <div className={`compact-h-scroll ${className}`.trim()}>
      <div ref={topRef} className="compact-h-scroll__top">
        <div ref={topInnerRef} className="compact-h-scroll__top-inner" />
      </div>
      <div ref={bodyRef} className="compact-h-scroll__body">
        <div ref={bodyInnerRef} className="compact-h-scroll__body-inner">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CompactHorizontalScroll;
